export default function WebGLFallback() {
  return (
    <div
      data-testid="webgl-fallback-view"
      className="fixed inset-0 z-50 flex flex-col items-center justify-center bg-[#050505] px-6 text-center"
    >
      <p className="font-mono text-xs tracking-[0.3em] text-[#FFC200]">SYSTEM ERROR</p>
      <h1 className="mt-4 font-heading text-2xl md:text-3xl uppercase text-[#E0E6ED]">
        WebGL2 Not Supported
      </h1>
      <p className="mt-4 max-w-md font-mono text-sm text-[#8A9AAB]">
        This experience requires a browser with WebGL2 support. Please open this
        site in a recent version of Chrome, Edge, Firefox, or Safari.
      </p>
    </div>
  );
}
